import { useEffect } from "react";
import * as helpers from "../../../../helpers/helpers";

export default function YearBuildField({
  register,
  watch,
  setValue,
  filterData,
  fieldNamePrefix = "",
}) {
  const yearOptions = helpers.getYearOptions();
  const yearBuild = watch(`${fieldNamePrefix}_year_build`);
  const yearBuildUntil = watch(`${fieldNamePrefix}_year_build_until`);

  useEffect(() => {
    if (setValue && yearBuild !== undefined) {
      
      
      if(fieldNamePrefix=== "recommend") {
        setValue("recommend_year_build", yearBuild);
        setValue("year_build", yearBuild);
      }
      if(fieldNamePrefix=== "building_lot") {
        setValue("building_lot_year_build", yearBuild);
        setValue("year_build", yearBuild);
      }
      
    }
  }, [yearBuild, setValue]);

  useEffect(() => {
  if (setValue && yearBuildUntil !== undefined) {
    if (fieldNamePrefix === "recommend") {
      setValue("recommend_year_build_until", yearBuildUntil); // ← FIXED
      setValue("year_build_until", yearBuildUntil);           // ← FIXED
    }
    if (fieldNamePrefix === "building_lot") {
      setValue("building_lot_year_build_until", yearBuildUntil); // ← FIXED
      setValue("year_build_until", yearBuildUntil);              // ← FIXED
    }
  }
}, [yearBuildUntil, setValue]);

  return (
    <div className="form_blk">
      <h6>Year built</h6>
      <div className="half_flex">
        <div className="half_field">
          <select
            name={`${fieldNamePrefix}_year_build`}
            id={`${fieldNamePrefix}_year_build`}
            className="input"
            {...register(`${fieldNamePrefix}_year_build`)}
            defaultValue={filterData?.[`${fieldNamePrefix}_year_build`] || ""}
          >
            <option value="">From</option>
            {yearOptions?.map((year, index) => {
              return (
                <option
                  value={year?.value}
                  key={index}
                  selected={
                    filterData?.[`${fieldNamePrefix}_year_build`] ===
                    year?.value
                      ? true
                      : false
                  }
                >
                  {year?.label}
                </option>
              );
            })}
          </select>
        </div>
        <span></span>
        <div className="half_field">
          <select
            name={`${fieldNamePrefix}_year_build_until`}
            id={`${fieldNamePrefix}_year_build_until`}
            className="input"
            {...register(`${fieldNamePrefix}_year_build_until`)}
            defaultValue={
              filterData?.[`${fieldNamePrefix}_year_build_until`] || ""
            }
          >
            <option value="">Until</option>
            {yearOptions?.map((year, index) => {
              return (
                <option
                  value={year?.value}
                  key={index}
                  selected={
                    filterData?.[`${fieldNamePrefix}_year_build_until`] ===
                    year?.value
                      ? true
                      : false
                  }
                >
                  {year?.label}
                </option>
              );
            })}
          </select>
        </div>
      </div>
    </div>
  );
}
